// Autogenerated Global Events

export function initGlobalEvents() {
  const el_homeBtnGlobal = document.getElementById('homeBtnGlobal');
  if (el_homeBtnGlobal) {
    el_homeBtnGlobal.addEventListener('click', function(event) {
      resetApp()
    });
  }

  const el_navDetectiveZoneBtn = document.getElementById('navDetectiveZoneBtn');
  if (el_navDetectiveZoneBtn) {
    el_navDetectiveZoneBtn.addEventListener('click', function(event) {
        if (window.DetectiveZoneModal) window.DetectiveZoneModal.open();
    });
  }

  const el_exitBtnGlobal = document.getElementById('exitBtnGlobal');
  if (el_exitBtnGlobal) {
    el_exitBtnGlobal.addEventListener('click', function(event) {
      const um = window.UserManager; if(um && um.isLoggedIn && um.isLoggedIn()) um.logout(); else { window.close(); if(!window.closed) alert('Para salir, por favor cierra la pestaña del navegador.'); }
    });
  }

  const el_auto_gen_id_1 = document.getElementById('auto-gen-id-1');
  if (el_auto_gen_id_1) {
    el_auto_gen_id_1.addEventListener('click', function(event) {
      showLoginScreen(true)
    });
  }

  const el_btnAudioProblemTypeTitle = document.getElementById('btnAudioProblemTypeTitle');
  if (el_btnAudioProblemTypeTitle) {
    el_btnAudioProblemTypeTitle.addEventListener('click', function(event) {
      toggleAudio(this, document.getElementById('problemTypeTitleText').textContent.replace(/^\d+\.\s*/, ''))
    });
  }

  const el_btnAudioLevelTitle = document.getElementById('btnAudioLevelTitle');
  if (el_btnAudioLevelTitle) {
    el_btnAudioLevelTitle.addEventListener('click', function(event) {
      toggleAudio(this, document.getElementById('levelTitleText').textContent.replace(/^\d+\.\s*/, ''))
    });
  }

  const el_btnAudioContextTitle = document.getElementById('btnAudioContextTitle');
  if (el_btnAudioContextTitle) {
    el_btnAudioContextTitle.addEventListener('click', function(event) {
      toggleAudio(this, document.getElementById('contextTitleText').textContent.replace(/^\d+\.\s*/, ''))
    });
  }

  // Removed prevStepBtn and nextStepBtn listeners as they are handled by config-manager.js

  const el_toggleProblemBtn = document.getElementById('toggleProblemBtn');
  if (el_toggleProblemBtn) {
    el_toggleProblemBtn.addEventListener('click', function(event) {
      toggleProblemText()
    });
  }

  const el_printProblemBtn = document.getElementById('printProblemBtn');
  if (el_printProblemBtn) {
    el_printProblemBtn.addEventListener('click', function(event) {
      previewProblemPDF()
    });
  }

  const el_auto_gen_id_6 = document.getElementById('auto-gen-id-6');
  if (el_auto_gen_id_6) {
    el_auto_gen_id_6.addEventListener('click', function(event) {
      goToWizardStep(1)
    });
  }

  const el_auto_gen_id_7 = document.getElementById('auto-gen-id-7');
  if (el_auto_gen_id_7) {
    el_auto_gen_id_7.addEventListener('click', function(event) {
      goToWizardStep(2)
    });
  }

  const el_auto_gen_id_8 = document.getElementById('auto-gen-id-8');
  if (el_auto_gen_id_8) {
    el_auto_gen_id_8.addEventListener('click', function(event) {
      goToWizardStep(3)
    });
  }

  const el_auto_gen_id_9 = document.getElementById('auto-gen-id-9');
  if (el_auto_gen_id_9) {
    el_auto_gen_id_9.addEventListener('click', function(event) {
      goToWizardStep(4)
    });
  }

  const el_auto_gen_id_10 = document.getElementById('auto-gen-id-10');
  if (el_auto_gen_id_10) {
    el_auto_gen_id_10.addEventListener('click', function(event) {
      goToWizardStep(5)
    });
  }

  const el_auto_gen_id_11 = document.getElementById('auto-gen-id-11');
  if (el_auto_gen_id_11) {
    el_auto_gen_id_11.addEventListener('click', function(event) {
      goToWizardStep(6)
    });
  }

  const el_comprehendedBtn = document.getElementById('comprehendedBtn');
  if (el_comprehendedBtn) {
    el_comprehendedBtn.addEventListener('click', function(event) {
      confirmComprehension(true)
    });
  }

  const el_helpBtn = document.getElementById('helpBtn');
  if (el_helpBtn) {
    el_helpBtn.addEventListener('click', function(event) {
      showProblemHelpModal()
    });
  }

  const el_btnContextIntro = document.getElementById('btnContextIntro');
  if (el_btnContextIntro) {
    el_btnContextIntro.addEventListener('click', function(event) {
      if (window.NarrativeManager && window.NarrativeManager.showIntroModal) {
        window.NarrativeManager.showIntroModal();
      }
    });
  }

  const el_topContextMiniBtn = document.getElementById('topContextMiniBtn');
  if (el_topContextMiniBtn) {
    el_topContextMiniBtn.addEventListener('click', function(event) {
      if (window.NarrativeManager && window.NarrativeManager.showIntroModal) {
        window.NarrativeManager.showIntroModal();
      }
    });
  }

  const el_auto_gen_id_16 = document.getElementById('auto-gen-id-16');
  if (el_auto_gen_id_16) {
    el_auto_gen_id_16.addEventListener('click', function(event) {
      validateHighlighting()
    });
  }

  const el_auto_gen_id_17 = document.getElementById('auto-gen-id-17');
  if (el_auto_gen_id_17) {
    el_auto_gen_id_17.addEventListener('click', function(event) {
      validateRepresentation()
    });
  }

  const el_validateLargestDataBtn = document.getElementById('validateLargestDataBtn');
  if (el_validateLargestDataBtn) {
    el_validateLargestDataBtn.addEventListener('click', function(event) {
      validateLargestData()
    });
  }

  const el_auto_gen_id_19 = document.getElementById('auto-gen-id-19');
  if (el_auto_gen_id_19) {
    el_auto_gen_id_19.addEventListener('click', function(event) {
      WorkBoard.open()
    });
  }

  const el_validateMagnitudeBtn = document.getElementById('validateMagnitudeBtn');
  if (el_validateMagnitudeBtn) {
    el_validateMagnitudeBtn.addEventListener('click', function(event) {
      validateMagnitude()
    });
  }

  const el_auto_gen_id_21 = document.getElementById('auto-gen-id-21');
  if (el_auto_gen_id_21) {
    el_auto_gen_id_21.addEventListener('click', function(event) {
      showReasoningHelp()
    });
  }

  const el_auto_gen_id_22 = document.getElementById('auto-gen-id-22');
  if (el_auto_gen_id_22) {
    el_auto_gen_id_22.addEventListener('click', function(event) {
      closeReasoningHelp()
    });
  }

  const el_checkTableBtn = document.getElementById('checkTableBtn');
  if (el_checkTableBtn) {
    el_checkTableBtn.addEventListener('click', function(event) {
      checkCalculationTable()
    });
  }

  const el_auto_gen_id_24 = document.getElementById('auto-gen-id-24');
  if (el_auto_gen_id_24) {
    el_auto_gen_id_24.addEventListener('click', function(event) {
      openAbnHelper()
    });
  }

  const el_auto_gen_id_25 = document.getElementById('auto-gen-id-25');
  if (el_auto_gen_id_25) {
    el_auto_gen_id_25.addEventListener('click', function(event) {
      openAbnHelper()
    });
  }

  const el_auto_gen_id_26 = document.getElementById('auto-gen-id-26');
  if (el_auto_gen_id_26) {
    el_auto_gen_id_26.addEventListener('click', function(event) {
      adjustCalcNumber(1)
    });
  }

  const el_auto_gen_id_27 = document.getElementById('auto-gen-id-27');
  if (el_auto_gen_id_27) {
    el_auto_gen_id_27.addEventListener('click', function(event) {
      adjustCalcNumber(-1)
    });
  }

  const el_validateCalcBtn = document.getElementById('validateCalcBtn');
  if (el_validateCalcBtn) {
    el_validateCalcBtn.addEventListener('click', function(event) {
      validateCalculation()
    });
  }

  const el_selectedFinalNumber = document.getElementById('selectedFinalNumber');
  if (el_selectedFinalNumber) {
    el_selectedFinalNumber.addEventListener('click', function(event) {
      showNumberTable('final')
    });
  }

  const el_goToCalcBtn = document.getElementById('goToCalcBtn');
  if (el_goToCalcBtn) {
    el_goToCalcBtn.addEventListener('click', function(event) {
      goToWizardStep(5)
    });
  }

  const el_submitFinalAnswerBtn = document.getElementById('submitFinalAnswerBtn');
  if (el_submitFinalAnswerBtn) {
    el_submitFinalAnswerBtn.addEventListener('click', function(event) {
      submitFinalAnswer()
    });
  }

  const el_auto_gen_id_28 = document.getElementById('auto-gen-id-28');
  if (el_auto_gen_id_28) {
    el_auto_gen_id_28.addEventListener('click', function(event) {
      closeNumberTable()
    });
  }

  const el_auto_gen_id_29 = document.getElementById('auto-gen-id-29');
  if (el_auto_gen_id_29) {
    el_auto_gen_id_29.addEventListener('click', function(event) {
      closeNumberTable()
    });
  }

  const el_tableSubmitBtn = document.getElementById('tableSubmitBtn');
  if (el_tableSubmitBtn) {
    el_tableSubmitBtn.addEventListener('click', function(event) {
      submitTableSelection()
    });
  }

  const el_tableCloseBtn = document.getElementById('tableCloseBtn');
  if (el_tableCloseBtn) {
    el_tableCloseBtn.addEventListener('click', function(event) {
      closeNumberTable()
    });
  }

  const el_auto_gen_id_30 = document.getElementById('auto-gen-id-30');
  if (el_auto_gen_id_30) {
    el_auto_gen_id_30.addEventListener('click', function(event) {
      closeErrorHelpModal()
    });
  }

  const el_auto_gen_id_34 = document.getElementById('auto-gen-id-34');
  if (el_auto_gen_id_34) {
    el_auto_gen_id_34.addEventListener('click', function(event) {
      closeAbnHelper()
    });
  }

  const el_auto_gen_id_35 = document.getElementById('auto-gen-id-35');
  if (el_auto_gen_id_35) {
    el_auto_gen_id_35.addEventListener('click', function(event) {
      closeAbnHelper()
    });
  }

  const el_btnAbnPrev = document.getElementById('btnAbnPrev');
  if (el_btnAbnPrev) {
    el_btnAbnPrev.addEventListener('click', function(event) {
      abnPreviousStep()
    });
  }

  const el_btnAbnNext = document.getElementById('btnAbnNext');
  if (el_btnAbnNext) {
    el_btnAbnNext.addEventListener('click', function(event) {
      abnNextStep()
    });
  }

  const el_btnAbnUse = document.getElementById('btnAbnUse');
  if (el_btnAbnUse) {
    el_btnAbnUse.addEventListener('click', function(event) {
      useAbnResult()
    });
  }

  const el_wizardPrevBtn = document.getElementById('wizardPrevBtn');
  if (el_wizardPrevBtn) {
    el_wizardPrevBtn.addEventListener('click', function(event) {
      if (window.wizardState && window.wizardState.currentWizardStep > 1) {
        window.goToWizardStep(window.wizardState.currentWizardStep - 1);
      }
    });
  }

  const el_wizardNextBtn = document.getElementById('wizardNextBtn');
  if (el_wizardNextBtn) {
    el_wizardNextBtn.addEventListener('click', function(event) {
      if (window.wizardState && window.wizardState.currentWizardStep < 6) {
        if (window.routeNextWizardStep) {
          window.routeNextWizardStep(window.wizardState.currentWizardStep);
        } else {
          window.goToWizardStep(window.wizardState.currentWizardStep + 1);
        }
      }
    });
  }

  const el_resetTableBtn = document.getElementById('resetTableBtn');
  if (el_resetTableBtn) {
    el_resetTableBtn.addEventListener('click', function(event) {
      resetTableSelections()
    });
  }

  const el_submitQuickAnswerBtn = document.getElementById('submitQuickAnswerBtn');
  if (el_submitQuickAnswerBtn) {
    el_submitQuickAnswerBtn.addEventListener('click', function(event) {
      submitQuickAnswer()
    });
  }

  const el_auto_gen_id_36 = document.getElementById('auto-gen-id-36');
  if (el_auto_gen_id_36) {
    el_auto_gen_id_36.addEventListener('click', function(event) {
      event.stopPropagation(); window.toggleAudioForAbnStep(this, 1)
    });
  }

  const el_auto_gen_id_37 = document.getElementById('auto-gen-id-37');
  if (el_auto_gen_id_37) {
    el_auto_gen_id_37.addEventListener('click', function(event) {
      event.stopPropagation(); window.toggleAudioForAbnStep(this, 2)
    });
  }

  const el_auto_gen_id_38 = document.getElementById('auto-gen-id-38');
  if (el_auto_gen_id_38) {
    el_auto_gen_id_38.addEventListener('click', function(event) {
      event.stopPropagation(); window.toggleAudioForAbnStep(this, 3)
    });
  }

  const el_downloadReportBtn = document.getElementById('downloadReportBtn');
  if (el_downloadReportBtn) {
    el_downloadReportBtn.addEventListener('click', function(event) {
      ReportGenerator.generateSessionReport()
    });
  }

}
